/* global axios */
import CacheEnabledApiClient from './CacheEnabledApiClient';

class Inboxes extends CacheEnabledApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  // eslint-disable-next-line class-methods-use-this
  get cacheModelName() {
    return 'inbox';
  }

  getCampaigns(inboxId) {
    return axios.get(`${this.url}/${inboxId}/campaigns`);
  }

  deleteInboxAvatar(inboxId) {
    return axios.delete(`${this.url}/${inboxId}/avatar`);
  }

  getAgentBot(inboxId) {
    return axios.get(`${this.url}/${inboxId}/agent_bot`);
  }

  setAgentBot(inboxId, botId) {
    return axios.post(`${this.url}/${inboxId}/set_agent_bot`, {
      agent_bot: botId,
    });
  }

  syncTemplates(inboxId) {
    return axios.post(`${this.url}/${inboxId}/sync_templates`);
  }

  getInteractiveGreetingConfig(inboxId) {
    return axios.get(`${this.url}/${inboxId}/interactive_greeting_config`);
  }

  updateInteractiveGreetingConfig(inboxId, config) {
    return axios.post(
      `${this.url}/${inboxId}/update_interactive_greeting_config`,
      { config }
    );
  }

  sendTestInteractiveGreeting(inboxId, phoneNumber) {
    return axios.post(`${this.url}/${inboxId}/send_test_interactive_greeting`, {
      phone_number: phoneNumber,
    });
  }

  getInstagramAutoReplyConfig(inboxId) {
    return axios.get(`${this.url}/${inboxId}/instagram_auto_reply_config`);
  }

  updateInstagramAutoReplyConfig(inboxId, config) {
    return axios.post(
      `${this.url}/${inboxId}/update_instagram_auto_reply_config`,
      { config }
    );
  }

  getInstagramMediaMonitoringConfig(inboxId) {
    return axios.get(
      `${this.url}/${inboxId}/instagram_media_monitoring_config`
    );
  }

  updateInstagramMediaMonitoringConfig(inboxId, config) {
    return axios.post(
      `${this.url}/${inboxId}/update_instagram_media_monitoring_config`,
      { config }
    );
  }

  createCSATTemplate(inboxId, template) {
    return axios.post(`${this.url}/${inboxId}/csat_template`, {
      template,
    });
  }

  getCSATTemplateStatus(inboxId) {
    return axios.get(`${this.url}/${inboxId}/csat_template`);
  }

  analyzeCSATTemplateUtility(inboxId, template) {
    return axios.post(`${this.url}/${inboxId}/csat_template/analyze`, {
      template,
    });
  }

  createMessageTemplate(inboxId, formData) {
    return axios.post(`${this.url}/${inboxId}/message_templates`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  deleteMessageTemplate(inboxId, name) {
    return axios.delete(`${this.url}/${inboxId}/message_templates/${name}`);
  }

  fetchTemplateLibrary(inboxId, { category, language } = {}) {
    const params = {};
    if (category) params.category = category;
    if (language) params.language = language;
    return axios.get(`${this.url}/${inboxId}/message_templates/library`, {
      params,
    });
  }

  resetSecret(inboxId) {
    return axios.post(`${this.url}/${inboxId}/reset_secret`);
  }

  enableWhatsappCalling(inboxId) {
    return axios.post(`${this.url}/${inboxId}/enable_whatsapp_calling`);
  }

  disableWhatsappCalling(inboxId) {
    return axios.post(`${this.url}/${inboxId}/disable_whatsapp_calling`);
  }

  setInboundCalls(inboxId, enabled) {
    return axios.post(`${this.url}/${inboxId}/set_inbound_calls`, {
      inbound_calls_enabled: enabled,
    });
  }
}

export default new Inboxes();
